"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Compass } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CustomSpacePlanning() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="custom-space-planning" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32 border-y border-border/50">
      {}
      <div className="absolute inset-0 opacity-15 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/abstract_blueprint_overlay.png')] bg-cover bg-center mix-blend-screen pointer-events-none" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_10%,transparent_100%)] opacity-20 pointer-events-none" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/40 to-background pointer-events-none" />

      <div ref={ref} className={`container mx-auto px-4 relative z-10 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-border/50 bg-secondary/30 backdrop-blur-md text-sm font-medium text-muted-foreground mb-8 shadow-sm">
          <Compass className="w-4 h-4 text-primary" />
          <span>Turnkey AV Solutions</span>
        </div>

        {}
        <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold tracking-tight mb-6 max-w-4xl text-balance">
          Your Vision, <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/70">Our Expertise.</span>
        </h2>

        {}
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-10 leading-relaxed text-balance">
          As a turnkey provider, Workplace Technology Solutions is your one-stop shop for comprehensive audiovisual systems. We specialize in delivering fully integrated, custom AV environments tailored to your unique business needs—from initial concept to final completion.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <Button asChild variant="secondary" size="lg" className="h-12 px-8 text-base border border-border/50 bg-secondary/80 backdrop-blur-sm hover:bg-secondary hover:border-border transition-all duration-300 shadow-lg shadow-black/20 group">
            <Link to="/ContactPage">
              Consult With Our Engineers
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}